<script>
export default {
	data: () => {
		return {
			copyrightDate: new Date().getFullYear(),
			author: 'IqbalARauf',
		};
	},
};
</script>

<template>
  <div class="flex justify-center items-center text-center">
    <div
      class="font-general-regular text-md text-ternary-dark dark:text-ternary-light"
    >
      &copy; {{ copyrightDate }}.
      Redesigned by
      <a
        href="https://iqbalarauf.my.id"
        target="__blank"
        class="font-general-medium text-secondary-dark dark:text-secondary-light hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 duration-500"
      >{{ author }}</a>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
